import styled from "@emotion/styled";
import { CertificationPassword } from "components/password/CertificationPassword";

import { koFindCorporationGuide, enFindCorporationGuide } from "components/password/helper";
import useTranslation from "hooks/useTranslation";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

type TTitleCompProps = {
  title: string;
  callbackOnClick: () => void;
  active: boolean;
};

export const CorporationPassword = () => {
  const [showResetPassword, setShowResetPassword] = useState<number>();
  const methods = useForm({
    mode: "onTouched",
  });
  const isEnglishPage = useTranslation();
  const findCorporationGuide = isEnglishPage ? enFindCorporationGuide : koFindCorporationGuide;
  return (
    <>
      <Summary>
        <span className="xicon-">info_border</span>
        <span>
          {isEnglishPage
            ? "Please select one of the verification methods to reset your password."
            : "비밀번호 재설정을 위해 아래의 인증 방식 중 한 가지를 선택해주세요."}
        </span>
      </Summary>
      <ContentsWrap>
        {findCorporationGuide.map((item, index) => (
          <div key={index}>
            <TitleComp
              title={item.title}
              active={showResetPassword === index}
              callbackOnClick={() => {
                setShowResetPassword(index);
              }}
            />
            <FormProvider {...methods}>
              {showResetPassword === index && (
                <Contents>
                  <p>{item.description}</p>
                  <CertificationPassword name={item.name} memberType="corporation" />
                </Contents>
              )}
            </FormProvider>
          </div>
        ))}
      </ContentsWrap>
    </>
  );
};

const TitleComp = ({ title, callbackOnClick, active }: TTitleCompProps) => {
  return (
    <Title active={active} onClick={callbackOnClick}>
      <h3>{title}</h3>
      <span aria-hidden className="xicon-">
        chevron_direction_down
      </span>
    </Title>
  );
};

const Summary = styled.div`
  display: flex;
  padding: 0px 8px;
  gap: 8px;
  color: ${({ theme }) => theme.color.mono[80]};
  margin-bottom: 24px;

  .xicon- {
    font-size: 18px;
  }

  > span:last-of-type {
    ${({ theme }) => theme.font.Caption}
  }
`;

const ContentsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 26px 22px 24px;
  background: ${({ theme }) => theme.color.primary[5]};
  border-radius: 8px;

  > h3 {
    ${({ theme }) => theme.font.Subtitle}
  }

  .xicon- {
    font-size: 24px;
    color: ${({ theme }) => theme.color.primary[60]};
    transition: 0.3s;
    ${({ active }) => active && "transform: rotate(180deg)"};
    cursor: pointer;
  }
`;

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 24px 32px;
  gap: 16px;

  > p {
    ${({ theme }) => theme.font.Caption}
    padding-left:4px;
    text-align: left;
  }
`;
